import React, { useEffect, useRef } from "react";
import { Col, Drawer, Form, Row, Button as AntdButton } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  FormInputNumber,
  FormInputArea,
  FormSwitch,
  FormHiddenSubmitButton,
} from "components/FormItems/FlatFormItems";
import { useForm } from "antd/lib/form/Form";
import { Button } from "components/Buttons/Buttons";

export default function PointsValuePolicyDrawer({
  data,
  visible,
  onClose,
  onSuccess,
}) {
  const [form] = useForm();
  const submitBtnRef = useRef();

  const isEdit = data?.loyaltyPointValuePolicyId !== undefined;

  useEffect(() => {
    if (visible === false) {
      form.resetFields();
    } else if (isEdit) {
      form.setFieldsValue({
        ...data,
      });
    }
  }, [visible]);

  return (
    <Drawer
      destroyOnClose
      headerStyle={{ border: "none" }}
      className="categoriesDrawer"
      width={"min(100vw, 420px)"}
      title={
        <div className="categoriesDrawerTitle">
          <p>{visible && (isEdit ? "Edit" : "Create")} Points Value Policy</p>
          <CloseOutlined onClick={onClose} />
        </div>
      }
      placement="right"
      onClose={onClose}
      visible={visible}
      closable={false}
      footer={
        <div className="categoriesDrawerFooter">
          <AntdButton type="text" onClick={onClose}>
            Cancel
          </AntdButton>
          <Button
            rounded
            type={"primary"}
            style={{ height: 50, width: "50%" }}
            onClick={() => submitBtnRef?.current?.click()}
          >
            Save
          </Button>
        </div>
      }
    >
      <Form
        preserve={false}
        layout="vertical"
        form={form}
        requiredMark={false}
        initialValues={{ isActive: true }}
        onFinish={(values) => {
          onSuccess(values);
        }}
        onFinishFailed={({ errorFields }) => {
          form.scrollToField(errorFields[0].name, {
            scrollMode: "if-needed",
            block: "center",
            behavior: "smooth",
          });
        }}
      >
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <FormInputNumber
              name="pointValueInDollars"
              variant="underlined"
              label="Point Value in Dollars"
              placeholder="Point Value in Dollars"
              min={0.01}
              required
              rules={[
                { required: true, message: "Required" },
                {
                  message: "Must be greater than 0",
                  validator: (_, value) => {
                    if (value === undefined || value === null || value <= 0) {
                      return Promise.reject();
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              formItemStyles={{marginBottom: 0}}
            />
          </Col>
          <Col xs={24}>
            <FormInputArea
              name="notes"
              variant="underlined"
              label="Notes"
              placeholder="Notes"
              formItemStyles={{ marginBottom: 0 }}
            />
          </Col>
          <Col xs={24}>
            <FormSwitch name="isActive" label="Active" />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <FormHiddenSubmitButton submitRef={submitBtnRef} />
        </Row>
      </Form>
    </Drawer>
  );
}
